import React from 'react';
import { Button, Table, Header, Segment } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import ThreeColumnTableRow from '../CreateCourse/ThreeColumnTableRow';
import { fetchFaculties, fetchStudyCycle, fetchLanguages, fetchAllAcademicYears } from '../../Lookups/util';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class DetailsEng extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            implementation: this.props.implementation,
            organizationalUnits: this.props.organizationalUnits,
            studyCycles: this.props.studyCycles,
            allLanguages: this.props.allLanguages,
            academicYears: this.props.academicYears,
            name: null,
            ects: null,
            durationYear: null,
            durationSemester: null,
            academicYearStart: null,
            studyCycle: null,
            studyProgramOrganizationalUnits: null,
            languages: null,
            classificationOfQualification: null,
            description: null,
            details: null,
            enrollmentTerms: null,
            gradingScale: null,
            nextCycleEnrollmentPossibility: null,
            professionalStatus: null,
            studyGoals: null,
            studyOutcomes: null,
            additionalInformation: null,
            studyRules: null,
            additionalInformationSource: null,

            edit: false
        };
        this.onChange = this.onChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.edit = this.edit.bind(this);
    }


    onChange(keyName, value) {
        this.setState({ [keyName]: value });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    getOrgUnitName(id) {
        const { organizationalUnits } = this.state;
        const selected = organizationalUnits.find(el => el.key === id);
        if (selected && selected.text) return selected.text;
        return '';
    }

    getStudyCycleName(id) {
        const { studyCycles } = this.state;
        const selected = studyCycles.find(el => el.key === id);
        if (selected && selected.text) return selected.text;
        return '';
    }

    getAcademicYearName(id) {
        const { academicYears } = this.state;
        const selected = academicYears.find(el => el.key === id);
        if (selected && selected.text) return selected.text;
        return '';
    }

    getLanguageName(id) {
        const { allLanguages } = this.state;
        const selected = allLanguages.find(el => el.key === id);
        if (selected && selected.text) return selected.text;
        return '';
    }

    edit() {
        const {
            implementation,
            name, classificationOfQualification, description, details, enrollmentTerms, gradingScale,
            nextCycleEnrollmentPossibility, professionalStatus, studyGoals, studyOutcomes, additionalInformation,
            studyRules, additionalInformationSource, languages
        } = this.state;

        if (name || classificationOfQualification || description || details || enrollmentTerms || gradingScale ||
            nextCycleEnrollmentPossibility || professionalStatus || studyGoals || studyOutcomes || additionalInformation ||
            studyRules || additionalInformationSource || languages) {
            this.setState({ edit: false });

            let editObj = { language: { twoLetterCode: 'en' } };

            if (name) editObj = { ...editObj, name };

            if (classificationOfQualification) editObj = { ...editObj, classificationOfQualification };
            if (description) editObj = { ...editObj, description };
            if (details) editObj = { ...editObj, details };
            if (enrollmentTerms) editObj = { ...editObj, enrollmentTerms };
            if (gradingScale) editObj = { ...editObj, gradingScale };
            if (gradingScale) editObj = { ...editObj, gradingScale };
            if (nextCycleEnrollmentPossibility) editObj = { ...editObj, nextCycleEnrollmentPossibility };
            if (professionalStatus) editObj = { ...editObj, professionalStatus };
            if (studyGoals) editObj = { ...editObj, studyGoals };
            if (studyOutcomes) editObj = { ...editObj, studyOutcomes };
            if (additionalInformation) editObj = { ...editObj, additionalInformation };
            if (studyRules) editObj = { ...editObj, studyRules };
            if (additionalInformationSource) editObj = { ...editObj, additionalInformationSource };


            let translations = [
                editObj,
            ];

            let obj = { id: implementation.studyProgram.id, optlock: implementation.studyProgram.optLock, translations };

            // Languages aren't translatable content (they're the study program's own teaching languages, a
            // top-level field on the implementation DTO, like studyCycles), and there's no bulk "set
            // languages" endpoint, only add-one/remove-one, so diff and call per language. These (and the
            // main update below) all modify the same StudyProgram row, so they must run sequentially, not
            // in parallel, to avoid an optimistic locking conflict (StaleStateException) from concurrent saves.
            const currentLanguageIds = (implementation.languages || []).map(el => el.id);
            const languageIdsToAdd = languages ? languages.filter(id => !currentLanguageIds.includes(id)) : [];
            const languageIdsToRemove = languages ? currentLanguageIds.filter(id => !languages.includes(id)) : [];
            const languageCallFns = [
                ...languageIdsToAdd.map(languageId => () => axios.post(`study-programs/add-language/${implementation.studyProgram.id}/${languageId}`)),
                ...languageIdsToRemove.map(languageId => () => axios.put(`study-programs/remove-language/${implementation.studyProgram.id}/${languageId}`))
            ];

            axios.put('study-programs/update-study-program', { ...obj })
                .then(res => languageCallFns.reduce((chain, fn) => chain.then(fn), Promise.resolve()).then(() => res))
                .then((res) => {
                    const newImplementation = { ...this.state.implementation, studyProgram: res.data };
                    if (languages) {
                        newImplementation.languages = this.props.allLanguages.filter(el => languages.includes(el.key)).map(el => ({ id: el.key, name: el.text }));
                    }
                    this.setState(
                        { implementation: newImplementation },
                        () => {
                            localStorage.setItem('implementation', JSON.stringify(this.state.implementation));
                        }
                    );
                    toast('Izmjena implementacije studijskog programa je uspješno izvršena.');
                })
                .catch(err => {
                    console.log(err);
                    toast('Došlo je do greške! Izmjena podataka nije izvršena.');
                });
        } else {
            toast('Morate unijeti nove podatke ukoliko želite izvršiti izmjenu!');
        }
    }

    render() {
        const { implementation } = this.state;
        console.log('implementation', implementation);
        return (
            <div>
                <Table celled unstackable compact>
                    <Table.Header>
                        <Table.Row>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        <ThreeColumnTableRow
                            name="Name"
                            keyName="name"
                            value={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').name : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').name : ''}
                        />
                        <ThreeColumnTableRow
                            name="ECTS"
                            keyName="ects"
                            value={implementation.studyProgram.ects}
                            onChange={this.onChange}
                            defValue={implementation.studyProgram.ects}
                        />
                        <ThreeColumnTableRow
                            name="Duration year"
                            keyName="durationYear"
                            value={implementation.studyProgram.durationYear}
                            onChange={this.onChange}
                            defValue={implementation.studyProgram.durationYear}
                        />
                        <ThreeColumnTableRow
                            name="Duration semester"
                            keyName="durationSemester"
                            value={implementation.studyProgram.durationSemester}
                            onChange={this.onChange}
                            defValue={implementation.studyProgram.durationSemester}
                        />
                        <ThreeColumnTableRow
                            name="Academic year start"
                            keyName="academicYearStart"
                            value={implementation.studyProgram.academicYearStart ? implementation.studyProgram.academicYearStart.name : ''}
                            onChange={this.handleInputChange}
                            academicYears={this.state.academicYears}
                            defValue={implementation.studyProgram.academicYearStart ? implementation.studyProgram.academicYearStart.name : ''}
                        />
                        <ThreeColumnTableRow
                            name="Study cycle"
                            keyName="studyCycle"
                            value={implementation.studyCycles ? implementation.studyCycles.map(el => (<div>{el.translations.find(e => e.language === 'en').displayName} <br /></div>)) : null}
                            onChange={this.handleInputChange}
                            studyCycles={JSON.parse(localStorage.getItem('studyCycles'))}
                            defValue={implementation.studyCycles ? implementation.studyCycles.map(el => (<div>{el.translations.find(e => e.language === 'en').displayName} <br /></div>)) : null}
                        />
                        <ThreeColumnTableRow
                            name="Study program organizational units"
                            keyName="studyProgramOrganizationalUnits"
                            value={implementation.organizationalUnitDTOs.length ? implementation.organizationalUnitDTOs.map(el => (<div>{el.nameEnglish} <br /></div>)) : null}
                            onChange={this.handleInputChange}
                            organizationalUnits={this.state.organizationalUnitDTOs}
                            defValue={implementation.organizationalUnitDTOs.length ? implementation.organizationalUnitDTOs.map(el => (<div>{el.nameEnglish} <br /></div>)) : null}
                        />
                        <ThreeColumnTableRow
                            name="Title name"
                            keyName="titleName"
                            value={implementation.studyProgramTitle.translations.length ? implementation.studyProgramTitle.translations.find(e => e.language === 'en').name : ''}
                            onChange={this.onChange}
                            disabled
                            defValue={implementation.studyProgramTitle.translations.length ? implementation.studyProgramTitle.translations.find(e => e.language === 'en').name : ''}
                        />
                        <ThreeColumnTableRow
                            name="Languages"
                            keyName="languages"
                            value={implementation.languages && implementation.languages.length ? implementation.languages.map(el => (<div key={el.id}>{el.nameEnglish || el.name} <br /></div>)) : null}
                            onChange={this.handleInputChange}
                            edit={this.state.edit}
                            languages={this.props.allLanguages}
                            defValue={implementation.languages ? implementation.languages.map(el => el.id) : []}
                        />

                        <ThreeColumnTableRow
                            name="Description"
                            keyName="description"
                            value={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').description : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').description : ''}
                        />
                        <ThreeColumnTableRow
                            name="Details"
                            keyName="details"
                            value={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').details : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').details : ''}
                        />
                        <ThreeColumnTableRow
                            name="Classification of qualification"
                            keyName="classificationOfQualification"
                            value={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').classificationOfQualification : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').classificationOfQualification : ''}
                        />
                        <ThreeColumnTableRow
                            name="Enrollment terms"
                            keyName="enrollmentTerms"
                            value={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').enrollmentTerms : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').enrollmentTerms : ''}
                        />
                        <ThreeColumnTableRow
                            name="Study rules"
                            keyName="studyRules"
                            value={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').studyRules : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').studyRules : ''}
                        />
                        <ThreeColumnTableRow
                            name="Grading scale"
                            keyName="gradingScale"
                            value={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').gradingScale : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').gradingScale : ''}
                        />

                        <ThreeColumnTableRow
                            name="Next cycle enrollment possibility"
                            keyName="nextCycleEnrollmentPossibility"
                            value={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').nextCycleEnrollmentPossibility : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').nextCycleEnrollmentPossibility : ''}
                            textArea
                        />
                        <ThreeColumnTableRow
                            name="Professional status"
                            keyName="professionalStatus"
                            value={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').professionalStatus : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').professionalStatus : ''}
                            textArea
                        />

                        <ThreeColumnTableRow
                            name="Study goals"
                            keyName="studyGoals"
                            value={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').studyGoals : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').studyGoals : ''}
                            textArea
                        />
                        <ThreeColumnTableRow
                            name="Study outcomes"
                            keyName="studyOutcomes"
                            value={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').studyOutcomes : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').studyOutcomes : ''}
                            textArea
                        />
                        <ThreeColumnTableRow
                            name="Additional information"
                            keyName="additionalInformation"
                            value={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').additionalInformation : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').additionalInformation : ''}
                            textArea
                        />

                        <ThreeColumnTableRow
                            name="Additional information source"
                            keyName="additionalInformationSource"
                            value={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').additionalInformationSource : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.translations.length ? implementation.studyProgram.translations.find(e => e.language === 'en').additionalInformationSource : ''}
                            textArea
                        />

                    </Table.Body>
                </Table>
                {(localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja' && localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta' ) ? !this.state.edit ?
                    <Button floated="right" primary onClick={() => this.setState({ edit: true })}>Izmijeni</Button>
                    : <div><Button floated="right" basic="true" color="blue" onClick={() => this.setState({ edit: false })}>Odustani</Button>
                        <Button floated="right" primary onClick={this.edit}>Sačuvaj izmjene</Button>
                    </div>: ''}
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgram/DetailsEng.js